/* Group-D extras: Australia delivery tick box + Enquire pop-up. Delegated so it also works inside quick-view pop-ups. */
(function () {
  function auBox(form) { return form && form.querySelector('.gd-au-confirm__box'); }
  function syncButtons(form) {
    var box = auBox(form); if (!box) return;
    form.querySelectorAll('button[type="submit"][name="add"]').forEach(function (b) {
      if (!box.checked) { b.setAttribute('data-gd-locked', '1'); b.classList.add('gd-locked'); }
      else { b.removeAttribute('data-gd-locked'); b.classList.remove('gd-locked'); }
    });
  }
  document.addEventListener('change', function (e) {
    if (e.target.classList && e.target.classList.contains('gd-au-confirm__box')) {
      var form = e.target.closest('form'); syncButtons(form);
      var msg = form && form.querySelector('.gd-au-confirm__msg'); if (msg && e.target.checked) msg.hidden = true;
    }
  });
  document.addEventListener('submit', function (e) {
    var box = auBox(e.target);
    if (box && !box.checked) {
      e.preventDefault(); e.stopImmediatePropagation();
      var msg = e.target.querySelector('.gd-au-confirm__msg'); if (msg) msg.hidden = false;
      box.focus();
    }
  }, true);
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('button[type="submit"][name="add"]');
    if (btn && btn.getAttribute('data-gd-locked') === '1') {
      e.preventDefault(); e.stopImmediatePropagation();
      var form = btn.closest('form') || document.getElementById(btn.getAttribute('form'));
      var msg = form && form.querySelector('.gd-au-confirm__msg'); if (msg) msg.hidden = false;
      return;
    }
    var open = e.target.closest && e.target.closest('.gd-enquire__open');
    if (open) { var d = document.getElementById('gd-enquire-' + open.getAttribute('data-gd-enquire')); if (d && d.showModal) d.showModal(); else if (d) d.setAttribute('open', ''); return; }
    if (e.target.tagName === 'DIALOG' && e.target.classList.contains('gd-enquire__dialog')) { if (e.target.close) e.target.close(); else e.target.removeAttribute('open'); return; }
    var close = e.target.closest && e.target.closest('.gd-enquire__close');
    if (close) { var dl = close.closest('dialog'); if (dl && dl.close) dl.close(); else if (dl) dl.removeAttribute('open'); }
  }, true);
  function init(root) { (root || document).querySelectorAll('form').forEach(syncButtons); }
  document.addEventListener('DOMContentLoaded', function () { init(); });
  new MutationObserver(function (m) { m.forEach(function (r) { r.addedNodes.forEach(function (n) { if (n.querySelectorAll) init(n); }); }); }).observe(document.documentElement, { childList: true, subtree: true });
  if (location.search.indexOf('contact_posted=true') > -1 || location.hash.indexOf('contact_form') > -1) {
    document.addEventListener('DOMContentLoaded', function () { var ok = document.querySelector('.gd-enquire__ok'); if (ok) { var d = ok.closest('dialog'); if (d && d.showModal) d.showModal(); } });
  }
})();


/* Group-D: combined make categories - one Category tick covers every value in its group, and removing its active-filter tag clears them all */
(function () {
  document.addEventListener('input', function (e) {
    var t = e.target;
    if (!t || !t.matches || !t.matches('input[data-gd-group]')) return;
    var f = t.closest('form'); if (!f) return;
    f.querySelectorAll('input[data-gd-group]').forEach(function (x) {
      if (x !== t && x.dataset.gdGroup === t.dataset.gdGroup) x.checked = t.checked;
    });
  }, true);
  document.addEventListener('click', function (e) {
    var a = e.target && e.target.closest && e.target.closest('a[data-gd-vals]');
    if (!a) return;
    var vals = (a.getAttribute('data-gd-vals') || '').split('\u2016');
    try {
      var u = new URL(a.getAttribute('href'), window.location.origin);
      var keep = u.searchParams.getAll('filter.p.product_type').filter(function (v) { return vals.indexOf(v) < 0; });
      u.searchParams.delete('filter.p.product_type');
      keep.forEach(function (v) { u.searchParams.append('filter.p.product_type', v); });
      a.setAttribute('href', u.pathname + (u.search || ''));
    } catch (err) {}
  }, true);
})();
